/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // ✅ Tambahkan useNavigate
import {
  AiOutlineArrowRight,
  AiOutlineEye,
  AiOutlineEyeInvisible,
} from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../Auth/Hooks/authSlice.jsx";
import Swal from "sweetalert2";
import { getDashboardPathForRole, getValidAuthSession, saveAuthSession, USER_ROLES } from "../../utils/authSession";

import "./LoginPage.css";

const LoginPage = () => {
  const navigate = useNavigate(); // ✅ Aktifkan navigate
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  React.useEffect(() => {
    const session = getValidAuthSession();
    if (session) navigate(getDashboardPathForRole(session.role), { replace: true });
  }, [navigate]);

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await dispatch(loginUser({ username, password })).unwrap();

      Swal.fire({
        icon: "success",
        title: "Login Berhasil",
        text: "Selamat datang!",
        timer: 2000,
        showConfirmButton: false,
      });

      const serverRole = result.role ?? result.user_info?.role ?? result.user?.role;
      const branchDescription = result.branch?.description?.toLowerCase() || "";
      const role = Object.values(USER_ROLES).includes(serverRole)
        ? serverRole
        : branchDescription.includes("pusat")
          ? USER_ROLES.HEAD_OFFICE
          : result.branch
            ? USER_ROLES.BRANCH_OFFICE
            : null;

      if (!role) throw new Error("Role pengguna tidak dikenali.");
      saveAuthSession({ token: result.token, role, expires: result.expires ?? result.expires_at });
      navigate(getDashboardPathForRole(role), { replace: true });

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Login Gagal",
        text: error?.message || "Terjadi kesalahan saat login.",
      });
    }
  };

  return (
    <div className="section-login">
      <div className="login-content">
        <div className="image-top-left">
          <img src="./asset_login_top.png" alt="Latar Jastan" />
        </div>
        <div className="content">
          <div className="content-left">
            <div className="header-content-login">
              <img src="./logo.png" alt="Logo Jastan" />
              <h2>Mitra Terpercaya Dalam Proteksi</h2>
              <p>
                Selamat datang di Jastan Claim – solusi asuransi terpadu Anda
                untuk ketenangan hidup, dengan kemudahan tanpa batas.
              </p>
            </div>
            <div className="icons-login">
              <img src="./asset_login_1.png" alt="Ikon Aset Jastan" />
            </div>
          </div>
          <div className="content-right">
            <div className="card-content">
              <div className="header-card">
                <span className="login-card-eyebrow">Jastan Claim</span>
                <h1>Masuk Akun</h1>
                <p>Gunakan akun anda.</p>
              </div>
              <form className="login-form" onSubmit={handleSubmit}>
                <label htmlFor="username">Nama Pengguna</label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  placeholder="22122"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="username"
                  required
                />
                <label htmlFor="password">Kata Sandi</label>
                <div className="password-input-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    placeholder="**********"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    required
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={toggleShowPassword}
                    aria-label={showPassword ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}
                  >
                    {showPassword ? (
                      <AiOutlineEyeInvisible />
                    ) : (
                      <AiOutlineEye />
                    )}
                  </button>
                </div>

                <div className="forgot-password">
                  <a href="#">Lupa kata sandi?</a>
                </div>

                <button
                  type="submit"
                  className="sign-in-btn"
                  disabled={loading}
                  aria-busy={loading}
                >
                  {loading && <span className="login-spinner" aria-hidden="true" />}
                  {loading ? "Memproses..." : "Masuk"}
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="image-bottom-right">
          <img src="./asset_login_bottom.png" alt="Latar Jastan" />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
